import { useRef, useState, useEffect } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Box, MenuItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
// components
import MenuPopover from '../../components/MenuPopover';

// ----------------------------------------------------------------------

const LANGS = [
  {
    value: 'fr',
    label: 'Français',
    icon: '/static/icons/fr.png',
    dir: 'ltr'
  },
  {
    value: 'ar',
    label: 'العربية',
    icon: '/static/icons/ar.png',
    dir: 'rtl'
  }
];

// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [lang, setLang] = useState(() =>
    localStorage.getItem('lang') ? localStorage.getItem('lang') : 'Français'
  );
  const [data, setData] = useState(LANGS.filter((i) => i.label === lang));

  useEffect(() => {
    switch (lang) {
      case 'Français':
        setData(LANGS[0]);
        break;
      case 'العربية':
        setData(LANGS[1]);
        break;
      default:
        setData(LANGS.filter((i) => i.label === lang));
    }
  }, [lang]);

  const [t, i18n] = useTranslation();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <img src={data.icon} width="25px" height="auto" alt={data.label} />
      </IconButton>
      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current}>
        <Box sx={{ py: 1 }}>
          {LANGS.map((option, key) => (
            <MenuItem
              key={option.value}
              selected={option.label === lang}
              onClick={() => {
                i18n.changeLanguage(option.value);
                document.body.setAttribute('dir', option.dir);
                handleClose();
                console.log('diroo', document.body.dir);
                setLang(option.label);
                localStorage.setItem('lang', option.label);
              }}
              sx={{ py: 1, px: 2.5 }}
            >
              <ListItemIcon>
                <Box
                  component="img"
                  width={20}
                  height="auto"
                  alt={option.label}
                  src={option.icon}
                />
              </ListItemIcon>
              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                {option.label}
              </ListItemText>
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
